import { render, staticRenderFns } from "./OrderInfoTitle.vue?vue&type=template&id=65c3f2ca"
import script from "./OrderInfoTitle.vue?vue&type=script&lang=js"
export * from "./OrderInfoTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports